/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Switch from "@mui/material/Switch";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";


// Images
import curved9 from "assets/images/curved-images/SAI_ERP_nube_render.png";
//import curved9 from "https://castelec.mx/images/PorqueSai/SAI_ERP_nube_render.webp";
import api_core from '../../../services/config.js'; 
import ConfirmOtp from "./Components/ConfirmOtp.jsx";
import { useNavigate } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {doLogin} from "../../../store/thunk/auth";

const initialStateCredentials = {
    sesion:{},
    token: '',
    email : '',
    nombres: '',
    apellidos:'',
    expires_in:'',
    expires:'',
    key:'',
    hasOtp :'',
    uuid:'',
    password:''
}

function SignIn() {
  const [rememberMe, setRememberMe] = useState(true);
  const navigate = useNavigate();
  const [errormessage, setErrorMessage] = useState('');
  const [credentials, setCredentials] = useState( initialStateCredentials );
  const { sesion,  token, email ,  nombres,  apellidos,  expires_i,  expire,  key,  hasOtp,  uuid} = credentials;
  let datax = {};

  const dispatch = useDispatch();
  const { user,  token:tokn, logged } = useSelector( state => state.auth );
  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  /* Login from de server  */
 const login  =   event => {
    event.preventDefault();




    let url = `panel/login`;

    if(credentials.email == ''){
      setErrorMessage(<label>Email requerido</label>);
      return false;
    }

    if(credentials.password == ''){
      setErrorMessage(<label>Contraseña requerida</label>);
      return false;
    }
    setErrorMessage(()=>('') );
    var bodyFormData = new FormData();
    bodyFormData.append(`rfc`, `duvj8602269l2`);
    bodyFormData.append(`serie`, `3`);
    bodyFormData.append(`email`, `${credentials.email}`);
    bodyFormData.append(`password`, `${credentials.password}`);

    api_core.post(`${url}`, bodyFormData )
      .then(res => {
        let data = res.data;
        if(!data.hasError){
          //datax = data;
          sessionStorage.setItem('tmp', JSON.stringify(data) );

          setCredentials( credentials => {
            return {
              sesion: JSON.stringify(data),  
              token:data.response.token, 
              email :data.response.email ,
              nombres:data.response.nombres,
              apellidos :data.response.apellidos,
              expires_i :data.response.expires_in, 
              expire : data.response.expires,
              key :data.response.uuid,
              hasOtp :data.response.hasOpt, 
              uuid : data.response.uuid,
              idle_timeout: data.idle_timeout,
            }
          });

          if(!data.response.hasOpt){
            setCredentials({
              ...credentials,
              'hasOpt' : false 
            });
            OnSuccessConfirm();
          }
        }else{
        }
      }).catch(function (error) {
        if (error.response) {
          setErrorMessage(()=>('Credenciales inválidas') );
        }
      })

 }

 const changePropiedades = ({target}) =>{
    setCredentials({
      ...credentials,
      [target.name] : target.value
    });
 }

 const OnSuccessConfirm = ()=>{
    const result =  JSON.parse(sessionStorage.getItem('tmp'));
    const {response} = result; 

     sessionStorage.removeItem('tmp');
     dispatch( doLogin( response ) );
 }

  return (
    <CoverLayout
      title={ "" }
      description=""
      image={curved9}
      >
        <SoftBox component="form" role="form" onSubmit={login} >

        {
          !credentials.uuid && (
              <>
                <SoftBox mb={2} >
          
                  <SoftBox mb={1} ml={0.5}>
                    <SoftTypography fontWeight="bold" sx={{ color:"#ababab",fontSize:"14px" }} >
                      { errormessage }
                    </SoftTypography>
                  </SoftBox>
                  
                  <SoftBox mb={1} ml={0.5}>
                    <SoftTypography   fontWeight="bold" sx={{ color:"#ffffff", fontSize:"12px" }}>
                      Email
                    </SoftTypography>
                  </SoftBox>
                  <SoftInput type="text" placeholder="Usuario" name="email" value={email}
                             error={credentials.email.length <= 4} onChange={event => changePropiedades(event) } required autoComplete="email" />
                </SoftBox>
                <SoftBox mb={2}>
                  <SoftBox mb={1} ml={0.5}>
                    <SoftTypography fontWeight="bold" sx={{ color:"#ffffff", fontSize:"12px" }}>
                      Contraseña
                    </SoftTypography>
                  </SoftBox>
                  <SoftInput type="password" placeholder="Password" value={credentials.password} name="password" autoComplete="current-password"
                             error={credentials.password.length <= 4} onChange={event => changePropiedades(event) } />
                </SoftBox>
                
                <SoftBox mt={4} mb={1}>
                  <SoftButton  color="color7A" type="submit" fullWidth >
                    Iniciar Sesión
                  </SoftButton>
                </SoftBox>
              </>
          )
        }
        </SoftBox>

        {
          credentials.hasOtp && <ConfirmOtp credentials={credentials} OnSuccessConfirm ={ OnSuccessConfirm } />
        }
      
        
        
        

      
    </CoverLayout>
  );
}


export default SignIn;
